import { fireEvent } from '#src/common/lib/events'
import { PRODUCT_LIST_IMPRESSION } from '#src/common/lib/events/topics'
import { removeUndefinedProperties } from '#src/common/lib/object'
import { capitalize } from '#src/common/lib/string'

type Product = {
  sku: string
  name: string
  categories: Categories[]
}

type Category = {
  name: string
  products: Product[]
}

type SelectedCategory = {
  name: string
  subcategories?: Category[]
  products?: Product[]
}

type SelectedSubCategory = {
  id: string
  name: string
}

type Categories = {
  id: string
  name: string
}

/* eslint-disable camelcase */
export const fireProductListImpressionEvent = (
  selectedCategory: SelectedCategory,
  selectedSubCategory: SelectedSubCategory,
  brand: string = 'Pret A Manger'
) => {
  const products = selectedCategory.subcategories?.length
    ? selectedCategory.subcategories.flatMap(
        subcategory => subcategory.products
      )
    : selectedCategory.products
  const item_category3 = selectedCategory.name
  const items = products.map(p => {
    const product = {
      item_id: p.sku,
      item_name: p.name,
      affiliation: 'Online Store',
      item_brand: capitalize(brand),
      item_category: 'Click and Collect',
      item_category3: item_category3
    }
    return removeUndefinedProperties(product)
  })

  const item_list_name =
    selectedSubCategory?.name?.toLowerCase() === 'all'
      ? item_category3
      : selectedSubCategory.name

  fireEvent(PRODUCT_LIST_IMPRESSION, {
    ecommerce: {
      item_list_id: selectedSubCategory?.id || '',
      item_list_name,
      items
    }
  })
}
